// Utility functions for filtering data
export function filterData(data, filters) {
  return data.filter(item => {
    return Object.keys(filters).every(key => {
      const filterValue = filters[key];
      const itemValue = item[key];
      
      if (!filterValue) return true;
      if (!itemValue) return false;
      
      return ciMatch(itemValue, filterValue);
    });
  });
}

// Case-insensitive string matching
export const ciMatch = (a, b) => (a || '').toString().toLowerCase() === (b || '').toString().toLowerCase();

// Case-insensitive string includes
export const ciIncludes = (a, b) => (a || '').toString().toLowerCase().includes((b || '').toString().toLowerCase());

// Date matching helper (supports both exact and partial matching)
export const dateMatches = (invoiceDate, filterDate) => {
  if (!filterDate) return true;
  if (!invoiceDate) return false;
  
  // Try exact match first
  if (invoiceDate === filterDate) return true;
  
  // Try partial match (just the date part)
  const invoiceDateOnly = invoiceDate.split('T')[0];
  return invoiceDateOnly === filterDate;
};

// Filter invoices with improved logic
export const filterInvoices = (invoices, filters, shopsMap = new Map()) => {
  return invoices.filter(inv => {
    // Shop name filter - use the mapped shopName
    if (filters.shopName && !ciMatch(inv.shopName, filters.shopName)) return false;
    
    // Location filter - check both invoice location and shop location
    if (filters.location) {
      const locationMatch = ciIncludes(inv.location, filters.location) || 
                          ciIncludes(inv.shopLocation, filters.location);
      if (!locationMatch) return false;
    }
    
    // Category filter
    if (filters.category && !ciMatch(inv.category, filters.category)) return false;
    
    // Date filter - improved matching
    if (filters.purchaseDate && !dateMatches(inv.date, filters.purchaseDate)) return false;
    
    return true;
  });
};

// Filter customers with improved logic
export const filterCustomers = (customers, filters) => {
  return customers.filter(cust => {
    // Customer number filter
    if (filters.customerNumber && !ciMatch(cust.phoneNumber, filters.customerNumber)) return false;
    
    // Location filter - check if customer has visited the location
    if (filters.location) {
      const hasVisitedLocation = cust.locationsVisited.some(loc => 
        ciIncludes(loc, filters.location) || ciMatch(loc, filters.location)
      );
      if (!hasVisitedLocation) return false;
    }
    
    return true;
  });
};

// Get unique values from arrays
export const getUniqueValues = (array, key) => {
  return Array.from(new Set(array.map(item => item[key]).filter(Boolean)));
};

// Get unique locations from shops
export const getUniqueShopLocations = (shops) => {
  const locations = shops.map(s => s.location).filter(Boolean);
  return Array.from(new Set(locations));
};

// Get unique categories from shops and invoices
export const getUniqueCategories = (shops, invoices) => {
  const shopCats = shops.map(s => s.category).filter(Boolean);
  const invoiceCats = (invoices || []).map(inv => inv.category).filter(Boolean);
  return Array.from(new Set([...shopCats, ...invoiceCats]));
};

// Get unique customer locations
export const getUniqueCustomerLocations = (customers) => {
  const locations = customers.flatMap(c => c.locationsVisited || []);
  return Array.from(new Set(locations)).filter(Boolean);
};

// Get unique customer numbers
export const getUniqueCustomerNumbers = (customers) => {
  return Array.from(new Set(customers.map(c => c.phoneNumber).filter(Boolean)));
};

// Get unique shop names
export const getUniqueShopNames = (shops) => {
  return Array.from(new Set(shops.map(s => s.name).filter(Boolean)));
}; 
